import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { AdminSmsDeliverabilityPanel } from "@/features/admin/components/AdminSmsDeliverabilityPanel";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/sms-deliverability")({
    component: SmsDeliverabilityPage,
});

function SmsDeliverabilityPage() {
    useNav([
        { label: "Developer", route: { to: "/developer" } },
        { label: "SMS issues", route: { to: "/developer/sms-deliverability" } },
    ]);

    return (
        <AdminPageLayout
            title="SMS Deliverability Issues"
            description="View SMS delivery failures and manage Knock preferences."
        >
            <AdminSmsDeliverabilityPanel />
        </AdminPageLayout>
    );
}
